module.exports = "/wwwroot/img/do_or_dont_do_block.png?ver=5c6260c5";